import React from 'react';
import { connect } from 'react-redux';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
;;
import { Button, Columns, Column, Container } from 'src/ui/mui-ui-kit';;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import propTypes from 'prop-types';
import { get } from 'lodash';
import { getUser } from 'src/user';
import {
  getAccount,
  getFormData,
  fetchAccount,
  fetchFormData,
} from 'src/account';
import { signOut, getSettings } from 'src/auth';
import {
  MyAccountPage,
  FISettingsPage,
  LoginHistoryPage,
  SettingsPage,
} from 'src/my-account';
import { ScheduledTasksPage } from 'src/my-account/views/ScheduledTasksPage';
import { getConsentTypesForAccount } from 'src/consent/services';
import { getDocumentTypesForAccount } from 'src/document/services';
import Tippy from '@tippy.js/react';
import { getMessages, fetchMessages } from 'src/messaging';
import { sanitizeHtml } from 'src/core/sanitizeHtml';
import {
  SideNav,
  // PoweredBySolvent,
  Breadcrumbs,
  AccountMenu,
} from '../components';
import {
  SUPER_ADMIN_ROUTES,
  SUPER_ADMIN_DASHBOARD_ROUTE,
  FIS_ROUTE,
  BANK_EMPLOYEE_ROUTES,
  EDITABLE_MERCHANT_DROPDOWN,
  BANK_ADMIN_ROUTES,
  MERCHANT_ADMIN_ROUTES,
  MERCHANT_EMPLOYEE_ROUTES,
  DOCUMENTS_ROUTE,
  CONSENTS_ROUTE,
  BANK_READ_ONLY_ROUTES,
  READ_ONLY_DROPDOWN,
  INSURANCE_ADMIN_ROUTES,
  INSURANCE_DROPDOWN,
  INSURANCE_USER_ROUTES,
  INSURANCE_AGENT_ROUTES,
  SOLVENTPAY_FI_ADMIN_ROUTE,
  SOLVENTPAY_MERCHANT_ADMIN_ROUTE,
} from '../const';

function getEditableMerchantDropdown(routes, user, account) {
  const newRoutes = routes.slice();

  if (user.accountId) {
    const editableMerchantDropdown = EDITABLE_MERCHANT_DROPDOWN(account);
    editableMerchantDropdown.label = user.accountName;
    newRoutes.push(editableMerchantDropdown);
  }
  return newRoutes;
}
function getReadOnlyDropdown(routes, user) {
  const newRoutes = routes.slice();

  if (user.accountId) {
    const editableMerchantDropdown = READ_ONLY_DROPDOWN(user);
    // editableMerchantDropdown.label = user.accountName;
    newRoutes.push(editableMerchantDropdown);
  }
  return newRoutes;
}
function getInsuranceDropdown(routes, user) {
  const newRoutes = routes.slice();

  if (user.accountId) {
    const editableMerchantDropdown = INSURANCE_DROPDOWN(user);
    editableMerchantDropdown.label = user.accountName;
    newRoutes.push(editableMerchantDropdown);
  }
  return newRoutes;
}

function getRoutes(user, account) {
  let routes = [];
  if (user.isSuperAdmin) {
    routes = routes.concat(SUPER_ADMIN_ROUTES);
    routes = getEditableMerchantDropdown(routes, user, account);
    // SolventPay Dashboard already includes Transactions - no need for legacy route
  } else if (user.isSolventAdmin) {
    // Solvent Admin gets:
    // - Payments Dashboard (SUPER_ADMIN_DASHBOARD_ROUTE)
    // - FI routes (FIS_ROUTE) for cross-FI access
    // - Bank admin routes (for FI Primary Admin powers)
    routes = routes.concat([SUPER_ADMIN_DASHBOARD_ROUTE, FIS_ROUTE]);
    routes = routes.concat(BANK_EMPLOYEE_ROUTES);
    routes = getEditableMerchantDropdown(routes, user, account);
    routes = routes.concat(BANK_ADMIN_ROUTES);
    // SolventPay Dashboard already includes Transactions - no need for legacy route
  } else if (user.isBankAdmin && user.financialInstitutionForInsurance) {
    routes = routes.concat(BANK_EMPLOYEE_ROUTES);
    routes = getInsuranceDropdown(routes, user, account);
    routes = routes.concat(INSURANCE_ADMIN_ROUTES);
  } else if (user.isMerchantAdmin && user.financialInstitutionForInsurance) {
    routes = routes.concat(INSURANCE_AGENT_ROUTES());
  } else if (user.isBankAdmin) {
    // Add SolventPay at the top for FI Admins with payment access
    if (user.financialInstitutionForPayments) {
      routes = routes.concat([SOLVENTPAY_FI_ADMIN_ROUTE]);
    }
    routes = routes.concat(BANK_EMPLOYEE_ROUTES);
    routes = getEditableMerchantDropdown(routes, user, account);
    routes = routes.concat(BANK_ADMIN_ROUTES);
    // SolventPay already includes Transactions - no need for legacy route
  } else if (user.isMerchantAdmin) {
    // Add SolventPay at the top for Merchant Admins with POS enabled
    if (account.enablePosPayments) {
      routes = routes.concat([SOLVENTPAY_MERCHANT_ADMIN_ROUTE]);
    }
    routes = routes.concat(MERCHANT_ADMIN_ROUTES(account));
  } else if (user.isBankReadOnly) {
    routes = routes.concat(BANK_READ_ONLY_ROUTES);
    routes = getReadOnlyDropdown(routes, user);
  } else if (user.financialInstitutionForInsurance) {
    routes = routes.concat(INSURANCE_USER_ROUTES);
  } else {
    routes = routes.concat(MERCHANT_EMPLOYEE_ROUTES);
  }
  routes = routes.filter(route => !!route.component || !!route.submenu);
  return routes;
}

const TerraPanel = ({
  user,
  account,
  signOut,
  formData,
  settings,
  messages,
  fetchAccount,
  fetchFormData,
  fetchMessages,
}) => {
  const [isLoadingData, setIsLoadingData] = React.useState(true);
  const [condensedSideNav, setCondensedSideNav] = React.useState(false);

  // undefined allows for Tippy to show on hover
  const [isReviewMessagesVisible, setIsReviewMessagesVisible] = React.useState(
    undefined
  );

  const sideNavContainerClassNames = classNames(
    'has-background-gradient-dark side-nav-container',
    {
      'is-condensed': condensedSideNav,
    }
  );
  const footerClassNames = classNames({
    'is-condensed': condensedSideNav,
  });

  const userName = user ? `${user.firstName} ${user.lastName}` : '';

  const lastMessage = React.useMemo(() => {
    return messages.items.filter(item => item.isFromFI).pop();
  }, [messages]);

  const location = useLocation();

  const getRedirect = () => {
    // Only redirect when at the root path
    if (location.pathname !== '/') {
      return null;
    }

    if (user.isMerchantAdmin) {
      if (!user.hasFinishedOnboarding) {
        return <Navigate to="/wizard" replace />;
      }
      if (user.isPasswordChangeRequired) {
        return <Navigate to="/change-password" replace />;
      }
    }

    if (user.isSuperAdmin || user.isSolventAdmin || user.isBankAdmin) {
      if (user.isPasswordChangeRequired) {
        return <Navigate to="/change-password" replace />;
      }
    }

    if (user.isMerchantEmployee) {
      if (!user.hasFinishedOnboarding) {
        return <Navigate to="/wizard" replace />;
      }
      if (user.isPasswordChangeRequired) {
        return <Navigate to="/change-password" replace />;
      }
    }

    if (user.isSuperAdmin) {
      return <Navigate to="/financial-institutions" replace />;
    }
    if (user.isSolventAdmin) {
      // Solvent Admin lands on SolventPay Dashboard Overview
      return <Navigate to="/solventpay/overview" replace />;
    }
    if (user.isBankAdmin) {
      // If FI has payments enabled, land on SolventPay dashboard
      if (user.financialInstitutionForPayments) {
        return <Navigate to="/solventpay/overview" replace />;
      }
      return <Navigate to="/accounts" replace />;
    }
    if (user.isBankReadOnly) {
      // FI read-only users have no /solventpay routes registered — always land on /accounts
      return <Navigate to="/accounts" replace />;
    }
    if (user.isMerchantAdmin && user.financialInstitutionForInsurance) {
      return <Navigate to="/people" replace />;
    }
    if (user.isMerchantAdmin) {
      // Wait for account to load before deciding redirect
      if (isLoadingData) {
        return null;
      }
      // If account has POS payments enabled, land on SolventPay dashboard
      if (account.enablePosPayments) {
        return <Navigate to="/solventpay/overview" replace />;
      }
      return <Navigate to="/business" replace />;
    }
    return <Navigate to={`/people/edit/${user.id}`} replace />;
  };

  React.useEffect(() => {
    (async () => {
      if (user.accountId && user.financialInstitutionId) {
        const firstLoad =
          (account.isEmpty() || formData.isEmpty()) &&
          !(account.isLoading() || formData.isLoading());

        const accountChange = user.accountId !== account.id;

        if (firstLoad || accountChange) {
          await Promise.all([
            fetchAccount(user.accountId),
            fetchFormData(user.financialInstitutionId, user.accountId),
            fetchMessages(user.financialInstitutionId, user.accountId),
          ]);

          if (lastMessage && !lastMessage.messageWasRead) {
            setIsReviewMessagesVisible();
          }
        }
      }
      setIsLoadingData(false);
    })();
  }, []);

  const toggleNarrowSidebar = () => {
    setCondensedSideNav(!condensedSideNav);
  };

  const toggleReviewMessage = () => {
    setIsReviewMessagesVisible(!isReviewMessagesVisible);
  };

  let listRoutes = getRoutes(user, account);
  const hiddenRoutes = {};

  let hasDocumentsOverride = false;
  let hasConsentsOverride = false;

  if (settings.selectedAccountId === user.accountId) {
    hasDocumentsOverride = settings.selectedAccountHasDocuments;
    hasConsentsOverride = settings.selectedAccountHasConsents;
  }

  // remove documents menu item if there are no documents
  if (
    !hasDocumentsOverride &&
    getDocumentTypesForAccount(account, formData).length === 0
  ) {
    hiddenRoutes[DOCUMENTS_ROUTE.to] = true;
  }

  // remove consents menu item if there are no consents
  if (
    !hasConsentsOverride &&
    getConsentTypesForAccount(account, formData).length === 0
  ) {
    hiddenRoutes[CONSENTS_ROUTE.to] = true;
  }

  listRoutes = listRoutes
    .filter(r => !hiddenRoutes[r.to])
    .map(lr => ({ ...lr }));
  listRoutes.forEach(lr => {
    if (lr.submenu) {
      // eslint-disable-next-line
      lr.submenu = lr.submenu.filter(lr => !hiddenRoutes[lr.to]);
    }
  });

  return (
    <Columns className="terra-panel" isGapless>
      <Column
        tag="aside"
        isSize="narrow"
        className={sideNavContainerClassNames}
      >
        <SideNav
          isCondensed={condensedSideNav}
          links={listRoutes.filter(
            route => (typeof route.showOnSidebar === 'function' ? route.showOnSidebar(user) : route.showOnSidebar)
          )}
          user={user}
        />
        <footer className={footerClassNames}>
          <AccountMenu
            user={{
              name: userName,
              bankName: '',
              ...user,
            }}
            onSignOut={signOut}
            isCondensed={condensedSideNav}
          />
          {/* < PoweredBySolvent visible={!condensedSideNav}  /> */}
        </footer>
      </Column>
      <Column className="wrapper">
        <Container className="top-nav">
          <Button
            isOutlined
            isSize="small"
            onClick={toggleNarrowSidebar}
            className="toggle-sidebar-button"
          >
            <span className="icon is-small">
              <FontAwesomeIcon icon={['fal', 'bars']} />
            </span>
          </Button>
          <Breadcrumbs />
          <div className="right-side">
            {user.isMerchantAdmin && messages.items.length > 0 && (
              <Tippy
                arrow
                distance={10}
                theme="danger"
                placement="bottom-end"
                content={
                  <div
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                      __html: sanitizeHtml(get(lastMessage, 'text', '')),
                    }}
                  />
                }
                hideOnClick={false}
                allowHTML
                delay={[0, 500]}
                visible={isReviewMessagesVisible}
              >
                <span>
                  <button
                    className="button is-small is-gradient-bright"
                    onClick={toggleReviewMessage}
                  >
                    <span className="icon is-small">
                      <FontAwesomeIcon
                        icon={['fal', 'comment-dots']}
                        size="lg"
                      />
                    </span>
                  </button>
                </span>
              </Tippy>
            )}
            <div className="custom-slot" />
          </div>
        </Container>
        <Container className="page">
          {getRedirect()}
          {!isLoadingData && (
            <Routes>
              {listRoutes.map(route =>
                !route.submenu ? (
                  <Route
                    path={route.path || route.to}
                    element={<route.component isExpanded={condensedSideNav} />}
                    key={route.label}
                    exact={route.exact}
                  />
                ) : route.component ? (
                  // Nested route with layout component (e.g., SuperAdminDashboardLayout)
                  <Route
                    path={route.path || route.to}
                    element={<route.component isExpanded={condensedSideNav} />}
                    key={route.label}
                  >
                    <Route index element={<Navigate to={route.submenu[0].path} replace />} />
                    {route.submenu.map(subroute => (
                      <Route
                        path={subroute.path}
                        element={<subroute.component isExpanded={condensedSideNav} />}
                        key={subroute.label}
                      />
                    ))}
                  </Route>
                ) : (
                  // Legacy submenu without layout (flattened routes)
                  route.submenu.map(subroute => (
                    <Route
                      path={subroute.path || subroute.to}
                      element={
                        <subroute.component isExpanded={condensedSideNav} />
                      }
                      key={subroute.label}
                      exact={subroute.exact}
                    />
                  ))
                )
              )}
              <Route
                path="/my-account"
                element={<MyAccountPage isExpanded={condensedSideNav} />}
              />
              <Route
                path="/login-history"
                element={<LoginHistoryPage isExpanded={condensedSideNav} />}
              />
              <Route
                path="/scheduled-tasks/*"
                element={
                  <ScheduledTasksPage
                    user={user}
                    isExpanded={condensedSideNav}
                  />
                }
              />
              <Route
                path="/fi-settings"
                element={
                  <FISettingsPage user={user} isExpanded={condensedSideNav} />
                }
              />
              <Route
                path="/settings"
                element={
                  <SettingsPage user={user} isExpanded={condensedSideNav} />
                }
              />
            </Routes>
          )}
        </Container>
      </Column>
    </Columns>
  );
};

TerraPanel.propTypes = {
  user: propTypes.object.isRequired,
  account: propTypes.object.isRequired,
  formData: propTypes.object.isRequired,
  settings: propTypes.object.isRequired,
  signOut: propTypes.func.isRequired,
  fetchAccount: propTypes.func.isRequired,
  fetchFormData: propTypes.func.isRequired,
  fetchMessages: propTypes.func.isRequired,
  messages: propTypes.object.isRequired,
};

const mapStateToProps = state => ({
  user: getUser(state),
  account: getAccount(state),
  formData: getFormData(state),
  settings: getSettings(state),
  messages: getMessages(state),
});

export const TerraPanelPage = connect(mapStateToProps, {
  signOut,
  fetchAccount,
  fetchFormData,
  fetchMessages,
})(TerraPanel);
